/**
 * O FOCO AO ABRIR UMA SOBREPOSIÇÃO (folha, janela, gaveta, diálogo).
 *
 * Quem abre pelo TECLADO precisa do foco no primeiro controle (p.29): é por
 * ali que ele continua. Quem abre pelo TOQUE ou pelo MOUSE não precisa — e o
 * foco posto pelo código num botão faz o navegador desenhar o anel de foco
 * (p.20), o contorno laranja em volta do "Cancelar" que o dono viu ao abrir
 * uma folha no iPhone. O anel não é removido de nada: só não se põe foco de
 * teclado em quem não está usando o teclado. O foco vai para o CONTÊINER da
 * sobreposição, que o leitor de tela anuncia, e o Tab entra nos controles,
 * que aí mostram o anel normalmente.
 */

let ultimaFoiTeclado = false;

if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener(
    'keydown',
    (e) => {
      if (e.key === 'Tab' || e.key.startsWith('Arrow') || e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') ultimaFoiTeclado = true;
    },
    true,
  );
  window.addEventListener(
    'pointerdown',
    () => {
      ultimaFoiTeclado = false;
    },
    true,
  );
}

/** Se a última interação foi pelo teclado. */
export function interacaoPeloTeclado(): boolean {
  return ultimaFoiTeclado;
}

/**
 * Foca o primeiro controle se a pessoa está no teclado; senão, o contêiner
 * (que precisa de `tabIndex={-1}`), sem rolar a tela.
 */
export function focarAoAbrir(conteiner: HTMLElement | null, primeiroControle: HTMLElement | null | undefined): void {
  if (ultimaFoiTeclado && primeiroControle) {
    primeiroControle.focus();
    return;
  }
  conteiner?.focus({ preventScroll: true });
}

/** Só para o teste: força a modalidade. */
export function definirModalidadeParaTeste(teclado: boolean): void {
  ultimaFoiTeclado = teclado;
}
